import { AppLoggerService } from './app-logger.service';

let logger: AppLoggerService | null = null;

export function initAppLog(instance: AppLoggerService): void {
    logger = instance;
}

function fallback(method: 'log' | 'warn' | 'error' | 'debug' | 'info', message?: unknown, ...args: unknown[]): void {
    console[method](message, ...args);
}

export const appLog = {
    log(message?: unknown, ...args: unknown[]): void {
        logger?.log(message, ...args) ?? fallback('log', message, ...args);
    },
    warn(message?: unknown, ...args: unknown[]): void {
        logger?.warn(message, ...args) ?? fallback('warn', message, ...args);
    },
    error(message?: unknown, ...args: unknown[]): void {
        logger?.error(message, ...args) ?? fallback('error', message, ...args);
    },
    debug(message?: unknown, ...args: unknown[]): void {
        logger?.debug(message, ...args) ?? fallback('debug', message, ...args);
    },
    info(message?: unknown, ...args: unknown[]): void {
        logger?.info(message, ...args) ?? fallback('info', message, ...args);
    },
};
